(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    /* Zoom : ouverture et fermeture instantanees. Pendant un clic dans la galerie,
     les transitions animees du navigateur sont suspendues une seconde. */
  var zoomInstantTimer;
  function zoomInstant() {
    document.documentElement.classList.add('zoom-instant');
    if ('startViewTransition' in Document.prototype) document.startViewTransition = undefined;
    clearTimeout(zoomInstantTimer);
    zoomInstantTimer = setTimeout(function () {
      document.documentElement.classList.remove('zoom-instant');
      delete document.startViewTransition;
    }, 1000);
  }
  document.addEventListener(
    'pointerdown',
    function (event) {
      var target = event.target;
      if (target instanceof Element && target.closest('media-gallery')) zoomInstant();
    },
    { capture: true }
  );
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key === 'Escape' && document.querySelector('.dialog-zoomed-gallery__dialog[open]')) zoomInstant();
    },
    { capture: true }
  );

  /* Zoom : precharge l'image en grand au survol, pour un affichage immediat au clic */
  document.addEventListener(
    'pointerover',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var gallery = target.closest('media-gallery');
      if (!gallery) return;
      var item = target.closest('.media-gallery__grid > li, slideshow-slide');
      if (!item || !item.parentElement) return;
      var index = Array.prototype.indexOf.call(item.parentElement.children, item);
      var zoomItem = gallery.querySelectorAll('.dialog-zoomed-gallery > li')[index];
      var image = zoomItem && zoomItem.querySelector('img.product-media__image');
      if (!image || image.dataset.zoomPreloaded) return;
      image.dataset.zoomPreloaded = '1';
      image.loading = 'eager';
      var highResolutionUrl = image.getAttribute('data_max_resolution');
      if (highResolutionUrl) {
        var preload = new Image();
        preload.src = highResolutionUrl;
      }
    },
    { passive: true }
  );
  } catch(e) { console.error(e); }
})();

})();
